
import { mapState } from 'vuex';
import SingleSelect from '@/components/ui/singleSelect';

export default {
  name: 'ClinicMenu',

  components: {
    SingleSelect,
  },

  props: {
    clinicSlug: {
      type: String,
      default: null,
    },
  },

  data() {
    return {
      slug: null,
    };
  },

  computed: {
    ...mapState(['clinics']),

    clinicOptions() {
      return this.clinics.map((c) => ({
        id: c.slug,
        name: c.title.rendered
          .replace(/&amp;/gi, '&')
          .replace(/&#8211;/gi, '-'),
      }));
    },
  },

  watch: {
    slug(value) {
      if (value) {
        this.$router.push(
          this.localePath({ name: 'clinic-slug', params: { slug: value } })
        );
      } else {
        this.$router.push(this.localePath({ name: 'clinic' }));
      }
    },
  },

  mounted() {
    this.slug = this.clinicSlug;
  },
};
